import { buildClientContext } from "./utils/clientContext";

const mergeClientContext = (state) => {
  if (!state || typeof state !== "object") {
    return state;
  }

  const defaultClientContext = buildClientContext();
  const existingClientContext = state.common?.clientContext || {};

  return {
    ...state,
    ...(state.cart ? {
      cart: {
        ...state.cart,
        saveCartLoading: false,
        getCartLoading: false,
        saveCartRequestId: null,
        lastSaveCartPayload: null,
      },
    } : {}),
    common: {
      ...(state.common || {}),
      clientContext: {
        device: existingClientContext.device || defaultClientContext.device,
        operating_system:
          existingClientContext.operating_system || defaultClientContext.operating_system,
        browser: existingClientContext.browser || defaultClientContext.browser,
        player_id:
          existingClientContext.player_id ?? defaultClientContext.player_id,
        unique_no: existingClientContext.unique_no || defaultClientContext.unique_no,
      },
    },
  };
};

export const loadState = () => {
    try {
      const serializedState = localStorage.getItem('reduxState');
      if (serializedState === null) {
        return undefined;
      }
      return mergeClientContext(JSON.parse(serializedState));
    } catch (err) {
      return undefined;
    }
  };
  export const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('reduxState', serializedState);
    } catch {
      // Handle errors, e.g., storage quota exceeded
    }
  };
